export default __webpack_public_path__ + "static/media/avatar-chat.fb73dadf.svg";